import {
  WIDTH_DOUBLE_AIGUILLAGE,
  WIDTH_SIMPLE_AIGUILLAGE,
  WIDTH_TEXT_VOIE,
} from '../constants/constants'
import {ESwitchType, TSwitch} from '../types/project.type'

export const getWidthAtPK = (switches: TSwitch[], pk: number) => {
  const switchAtPK = switches.find(sw => sw.kmPoint === pk)
  if (!switchAtPK) {
    return WIDTH_TEXT_VOIE
  }

  return switchAtPK.type === ESwitchType.DOUBLE
    ? WIDTH_DOUBLE_AIGUILLAGE
    : WIDTH_SIMPLE_AIGUILLAGE
}
